<template>
  <div data-dusk="automation-badge">
    {{ automationName }}
  </div>
</template>

<script>

export default {
  name: "AutomationBadgeComponent",
  props: {
    automation: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {};
  },
  components: {},
  created() {
  },
  computed: {
    automationName() {
      return this.automation.title;
    },
  },
  methods: {},
};
</script>


<style scoped>
</style>
